import React, { FC } from 'react';
import styled from 'src/theme';
import { Col, Row } from "antd";
import { orionLogoJPG } from 'src/assets/images';

export const Header: FC = ({children}) => {
  return (
    <Row>
      <Col xs={24}>
        <LogoStyled src={orionLogoJPG} />
        <HeaderStyled>{children}</HeaderStyled>
      </Col>
    </Row>
  );
};

const HeaderStyled = styled.h1`
  position: relative;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  padding: 50px 0;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    padding: 75px 0 25px;
  }
`;

const LogoStyled = styled.img`
  position: absolute;
  width: 120px;
  height: auto;
  right: 0;
  top: 75px;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    top: 10px;
  }
`;
